<template>
    <div class="modal-row2  modal-content">
        <div class="modal-body">
            <div class="row gutters pl-2 pr-2 pt-3 pb-3">
                <div class="col-12">
                    <div class="form-group">
                        <label class="required">Loteamento</label>
                        <Select2 :settings="{width:'100%'}" :options="allotmentsState" placeholder="Selecione"
                        v-model="allotmentId"></Select2>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label class="required">Aumentar duração: (HH:MM)</label>
                        <input type="text" id="duration" placeholder="HH:MM"
                               class="form-control"
                               v-model="timeduration"
                               v-mask="getDurationMask()"
                        >
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="d-flex flex-row justify-content-end">
                <button class="btn btn-secondary mr-1" @click="closeModal">Fechar</button>
                <button class="btn btn-primary" @click="save">Salvar</button>
            </div>
        </div>
    </div>
</template>

<script>
import Select2 from 'vue3-select2-component';
import {mapState} from 'vuex';
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import Reserves from '../../services/Reserves';
export default {
    name: "modalPlusTimeReserve",
    components:{
        Select2
    },
    mounted() {
        if (localStorage.getItem('reserveAllotmentId') && localStorage.getItem('reserveAllotmentId') !== 'all'){
            this.allotmentId = localStorage.getItem('reserveAllotmentId');
        }
    },
    data(){
        return{
            timeduration: null,
            allotmentId: null,
        }
    },
    computed:{
        ...mapState({
            allotmentsState: 'allotments',
        })
    },
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast};
    },
    methods:{
        getDurationMask()
        {
            if(this.timeduration?.length <= 5){
                return ['##:##']
            }else if (this.timeduration?.length === 6){
                return ['###:##']
            }else {
                return ['####:##']
            }
        },
        validateFields(){
            let valid = true;
            if (!this.allotmentId){
                valid = false;
                this.toast.error('Necessário selecionar um loteamento');
            }
            if (!this.timeduration || this.timeduration?.length < 5){
                this.toast.error('Necessário informar hora e minuto, formato mínimo 00:01');
                return false;
            }
            const [hours, minutes] = this.timeduration.split(':');
            if (hours && minutes.length === 2) {
                const minutesNum = parseInt(minutes, 10);
                if (minutesNum >= 60) {
                    valid = false;
                    this.toast.error("Minutos devem ser entre 00 e 59!");
                }
            }
            return valid;
        },
        save()
        {
            if (this.validateFields()){
                this.$store.commit('changeLoading', true);
                Reserves.plusTime(this.allotmentId,  this.timeduration).then((resp) => {
                    this.toast.success( resp?.data?.validations?.message)
                    document.getElementById('closeX')?.click();
                }).catch((err) => {
                    this.$store.commit('changeLoading', false);
                    this.errorMsg(err);
                })
            }
        },
        closeModal(){
            document.getElementById('closeX')?.click();
        }
    }
}
</script>

<style scoped>

</style>